// Name-search dropdown. The list is no longer server-rendered: names ship as a
// JSON blob (#staffNamesData) and the DOM rows are built once, on first focus,
// to keep the initial DOM small (PageSpeed "excessive DOM size").
export const typeToOpenSearch = (...args) => {
    const [inputElem, staffItemElems, dropdownElem] = args;
    const input = document.querySelector(inputElem);
    const dropdown = document.querySelector(dropdownElem);
    if (!input || !dropdown) {
        return;
    }

    const dataEl = document.getElementById('staffNamesData');
    let staffItems = Array.from(dropdown.querySelectorAll(staffItemElems));
    let built = !dataEl; // no JSON blob = legacy server-rendered list
    if (built && !staffItems.length) {
        return;
    }

    const bindItem = (item) => {
        item.addEventListener('click', function () {
            input.value = this.dataset.name;
            dropdown.style.display = 'none';
            window.location.href = this.dataset.url;
        });
        item.addEventListener('mouseenter', () => item.style.backgroundColor = '#495057');
        item.addEventListener('mouseleave', () => item.style.backgroundColor = 'transparent');
    };
    staffItems.forEach(bindItem);

    const buildOnce = () => {
        if (built) return;
        built = true;
        let list = [];
        try { list = JSON.parse(dataEl.textContent) || []; } catch (e) {}
        const holder = dropdown.querySelector('.dropdown-staff-list') || dropdown;
        const frag = document.createDocumentFragment();
        list.forEach((s) => {
            const div = document.createElement('div');
            div.className = 'staff-item p-2 cursor-pointer text-default rounded-2';
            div.dataset.url = s.u;
            div.dataset.name = s.n;
            div.textContent = s.n;
            bindItem(div);
            frag.appendChild(div);
        });
        holder.appendChild(frag);
        staffItems = Array.from(dropdown.querySelectorAll(staffItemElems));
    };

    document.addEventListener('click', (e) => {
        if ((!dropdown.contains(e.target) && !input.contains(e.target)) || e.target.classList.contains('btnClose')) {
            dropdown.style.display = 'none';
        }
    });

    const open = () => { buildOnce(); dropdown.style.display = 'block'; };
    input.addEventListener('focus', open);
    input.addEventListener('click', open);

    input.addEventListener('input', function () {
        buildOnce();
        const term = this.value.toLowerCase();
        let hasVisible = false;

        staffItems.forEach(item => {
            const match = item.dataset.name.toLowerCase().includes(term);
            item.style.display = match ? 'block' : 'none';
            if (match) hasVisible = true;
        });

        dropdown.style.display = hasVisible ? 'block' : 'none';
    });
}
